"use client";

import React, {useEffect, useState} from "react";
import Button from '@/components/ui/Button';

const COOKIE_NAME = 'landing-autogarantcity-metrica-consent';

export const setCookiesConsent = (): void => {
    document.cookie = `${COOKIE_NAME}=1; max-age=31536000; samesite=lax; path=/`;
    // Триггерим событие для обновления других компонентов
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('cookiesConsentChanged', { detail: { consented: true } }));
    }
};

export const checkCookiesConsent = (): boolean => {
    if (typeof document === 'undefined') return false;
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    return cookies.includes(`${COOKIE_NAME}=1`);
};

export const AcceptCookies: React.FC = () => {
    // Инициализируем состояние как null для предотвращения мигания
    // null = еще не проверили, false = нужно показать, true = скрыть
    const [shouldShow, setShouldShow] = useState<boolean | null>(null);

    useEffect(() => {
        // Проверяем согласие при монтировании
        const hasConsent = checkCookiesConsent();
        setShouldShow(!hasConsent);
    }, []);

    const handleAccept = (): void => {
        setCookiesConsent();
        setShouldShow(false);
    };

    // Не показываем окно, пока не проверили состояние или если согласие уже дано
    if (shouldShow === null || shouldShow === false) return null;

    return (
        <div className="fixed left-0 bottom-0 z-50">
            <div className="bg-white rounded-t-2xl shadow-2xl max-w-full w-full mx-auto">
                <div className="p-2 md:p-4">
                    <div className="flex items-start justify-between mb-2">
                        <div className="flex items-center space-x-3">
                            <div className="w-8 h-8 bg-primary-dark rounded-lg flex items-center justify-center">
                                <svg className="w-4 h-4 text-primary-accent" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                          clipRule="evenodd"/>
                                </svg>
                            </div>
                            <h3 className="text-xs font-bold uppercase text-text-accent">
                                Файлы cookie
                            </h3>
                        </div>
                    </div>
                    <div className="mb-3">
                        <p className="text-xs text-black leading-relaxed">
                            Этот сайт использует сервис веб-аналитики Яндекс Метрика, предоставляемый компанией ООО «ЯНДЕКС», 119021, Россия, Москва, ул. Л. Толстого, 16 для анализа пользовательской активности через «cookie».
                            Информация, собранная посредством cookie, не идентифицирует вас, но помогает улучшить сайт.
                            Данные передаются и хранятся на сервере Яндекса в РФ и/или ЕЭЗ для оценки использования вами сайта, составления отчетов об активности на сайте.
                            Вы можете отказаться от использования cookie через настройки браузера или перейдя по {' '}
                            <a className="text-text-custom-light-orange hover:text-custom-light-orange underline transition-colors" href={'https://yandex.ru/support/metrika/general/opt-out.html'} target={'_blank'}>ссылке</a>.
                        </p>
                        <p className="text-xs text-black leading-relaxed font-bold uppercase">Оставаясь на сайте, вы соглашаетесь с обработкой данных в указанных целях.</p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <Button className={'border-[#b89d7e] text-[#b89d7e] p-[14px_45px] text-[20px] font-normal tracking-[-0.02em] hover:bg-[#b89d7e] hover:text-white w-full mt-3 py-3 px-4'} onClick={handleAccept}>
                            Принять
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
